import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import Header from '../../Common/Layout/Header';
import { useAuth } from '../../Common/Configurations/AuthContext';
import { Link } from 'react-router-dom';
import DeleteAlert from '../../Common/Layout/DeleteAlert';
import Login from '../../Authentication/Login';
import moment from 'moment';
import HajjTabs from '../AllTabs/HajjTabs';


const HajjEnquiry = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate(); 
    const [lists, setLists] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [data, setData] = useState([]);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);

    const handleOpenDeleteModal = (id) => {
        setItemToDelete(id);
        setShowDeleteModal(true);
    };
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setItemToDelete(null);
    };

    const handleOpenViewModal = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setShowViewModal(true);
    };

    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setSelectedEnquiry(null);
    };

    const GetData = async (pageNumber) => {
        const enquiryType = 'Hajj';
        const url = `${config.GETENQUIRYBYTYPE}/${user.cid}?type=${enquiryType}`;
        const res = await apiService.getAll(url, pageSize, pageNumber);
        setLists(res.data);
        setPageNumber(res.pageNumber);
        setPageSize(res.pageSize);
        setTotalPages(res.totalPages);
        setData(res.data);
        setTotalRecords(res.totalRecords);
    };

    const GetLastPageData = () => {
        GetData(totalPages)
    }
    const GetFirstPageData = () => {
        GetData("1")
    }
    const GetPageData = (number) => {
        setPageNumber(number);
        if (pageNumber !== number)
            GetData(number)
    }
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map((number) => {
        return (
            <li className="page-item" key={number} id={number} onClick={() => GetPageData(number)}>
                <Link className="page-link">{number}</Link>
            </li>
        );
    });
    useEffect(() => {
            if (!loading && !user) {
                navigate("/");
            }
        }, [user, loading, navigate]);
    
        useEffect(() => {
            if (user) {
                GetData(pageNumber);
            }
        }, [user, pageNumber]);
      
        if (loading) {
            return <p>Loading...</p>;
        }
    const handleDelete = async () => {
        if (itemToDelete !== null) {
            try {
                await apiService.remove(config.DELETEPACKAGEENQUIRY, itemToDelete);
                await GetData(pageNumber);
                handleCloseDeleteModal();
            } catch (error) {
                handleCloseDeleteModal();
            }
        }
    };
    const RenderViewModal = () => {
        if (!showViewModal || !selectedEnquiry) {
            return null;
        }

        const modalStyle = {
            display: 'block',
            backgroundColor: 'rgba(0,0,0,0.5)',
        };

        return (
            <div className="modal fade show" style={modalStyle} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header bg-soft-primary">
                            <h5 className="modal-title">Enquiry Details for {selectedEnquiry.name}</h5>
                            <button type="button" className="btn-close" onClick={handleCloseViewModal} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row mb-3">
                                <div className="col-lg-4 text-center">
                                    <img
                                        src={selectedEnquiry.profileSrc}
                                        alt="Profile"
                                        className="rounded-circle avatar-xl img-thumbnail"
                                        onError={(e) => { e.target.onerror = null; e.target.src = "/assets/images/ProfileIcon.png"; }}
                                    />
                                    <h5 className='mt-2 mb-0'>{selectedEnquiry.name}</h5>
                                    <p className="text-muted">{selectedEnquiry.email}</p>
                                </div>
                                <div className="col-lg-8">
                                    <h5 className="mb-3">Personal & Package Information</h5>
                                    <div className="table-responsive">
                                        <table className="table table-sm table-borderless">
                                            <tbody>
                                                <tr><th scope="row" style={{ width: "30%" }}>Package Name</th><td>{selectedEnquiry.packageName}</td></tr>
                                                <tr><th scope="row">Destination</th><td>{selectedEnquiry.destinatioName}</td></tr>
                                                <tr><th scope="row">Phone Number</th><td>{selectedEnquiry.phoneNumber}</td></tr>
                                                <tr><th scope="row">Nationality</th><td>{selectedEnquiry.nationality}</td></tr>
                                                <tr><th scope="row">Comments</th><td>{selectedEnquiry.comments}</td></tr>
                                                <tr><th scope="row">Enquiry Date</th><td>{moment(selectedEnquiry.createdDate).format("DD-MMM-YYYY, hh:mm A")}</td></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <h5 className="mb-3">Submitted Documents</h5>
                            <div className="row text-center">
                                <div className="col-md-3 col-6 mb-3">
                                    <h6>Passport Front</h6>
                                    {selectedEnquiry.passportFrontSrc ? <a href={selectedEnquiry.passportFrontSrc} target="_blank" rel="noopener noreferrer"><img src={selectedEnquiry.passportFrontSrc} className="img-fluid img-thumbnail" alt="Passport Front" /></a> : <p className="text-muted">Not Provided</p>}
                                </div>
                                <div className="col-md-3 col-6 mb-3">
                                    <h6>Passport Back</h6>
                                    {selectedEnquiry.passportBackSrc ? <a href={selectedEnquiry.passportBackSrc} target="_blank" rel="noopener noreferrer"><img src={selectedEnquiry.passportBackSrc} className="img-fluid img-thumbnail" alt="Passport Back" /></a> : <p className="text-muted">Not Provided</p>}
                                </div>
                                <div className="col-md-3 col-6 mb-3">
                                    <h6>Aadhar Card</h6>
                                    {selectedEnquiry.aadharSrc ? <a href={selectedEnquiry.aadharSrc} target="_blank" rel="noopener noreferrer"><img src={selectedEnquiry.aadharSrc} className="img-fluid img-thumbnail" alt="Aadhar" /></a> : <p className="text-muted">Not Provided</p>}
                                </div>
                                <div className="col-md-3 col-6 mb-3">
                                    <h6>Vaccination Proof</h6>
                                    {selectedEnquiry.vaccinationSrc ? <a href={selectedEnquiry.vaccinationSrc} target="_blank" rel="noopener noreferrer"><img src={selectedEnquiry.vaccinationSrc} className="img-fluid img-thumbnail" alt="Vaccination" /></a> : <p className="text-muted">Not Provided</p>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleCloseViewModal}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };


    if (loading) return <p>Loading...</p>;
    if (!user) return <Login />;

    return (
        <div id="layout-wrapper">
            <Header User={user} />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="p-2">
                                    <HajjTabs pageName="HAJJENQUIRIES" />
                                </div>
                                <div className="card-header">
                                    <h4 className="card-title mb-0">Hajj Enquiries</h4>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive table-card p-2">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="bg-soft-success bg-gradient">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Customer Name</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Package Name</th>
                                                    <th>Destination</th>
                                                    <th>Enquiry Date</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {lists.length > 0 ? lists.map((v, index) =>
                                                    <tr key={v.packageEnquiryId}>
                                                        <td>{((pageNumber - 1) * pageSize) + index + 1}</td>
                                                        <td>{v.name}</td>
                                                        <td>{v.email}</td>
                                                        <td>{v.phoneNumber}</td>
                                                        <td>{v.packageName}</td>
                                                        <td>{v.destinatioName}</td>
                                                        <td>{moment(v.createdDate).format("DD-MMM-YYYY")}</td>
                                                        <td>
                                                            <ul className="list-inline hstack gap-2 mb-0">
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="View">
                                                                    <Link className="view-item-btn" onClick={() => handleOpenViewModal(v)}>
                                                                        <i className="ri-eye-fill align-bottom text-muted" />
                                                                    </Link>
                                                                </li>
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Delete">
                                                                    <Link className="remove-item-btn" onClick={() => handleOpenDeleteModal(v.packageEnquiryId)}>
                                                                        <i className="ri-delete-bin-fill align-bottom text-muted" />
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <tr><td colSpan="8" className="text-center">No enquiries found.</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                        <div className="flex-shrink-0">
                                            <div className="text-muted">
                                                Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                            </div>
                                        </div>
                                        <ul className="pagination pagination-separated pagination-sm mb-0">                                             <li className={"page-item" + data.previousPage === null ? 'disabled' : ''} onClick={() => GetFirstPageData()}>
                                            <Link className="page-link">Previous</Link>
                                        </li>
                                            {renderPageNumbers}
                                            <li className={"page-item" + data.nextPage === null ? 'disabled' : ''} onClick={() => GetLastPageData()}>
                                                <Link className="page-link">Next</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <RenderViewModal />

                <DeleteAlert show={showDeleteModal} handleClose={handleCloseDeleteModal} handleDelete={handleDelete} />
            </div>
        </div>
    );
};

export default HajjEnquiry;